import React from 'react';
import SelectedProduct from './SelectedProduct'
import { useAddProductContext } from '../../../Contexts/AddProductContext';
import { TbPhotoX } from 'react-icons/tb';
import { isNewProductOnCatalog, useQuantityProductInCartConference } from '../../../Utils/Helpers';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';

interface CardProductGridImageProps {
    product: any;
    category: any;
    loading?: boolean;
    className?: any;
}

const CardProductGridImage = ({
    product,
    category,
    loading,
    className,
}: CardProductGridImageProps) => {

    const { setShowAddProduct, setProduct, setCategory } = useAddProductContext();

    const handleProduct = () => {
        setShowAddProduct(true);
        setProduct(product);
        setCategory(category);
    }

    const quantitySelected = useQuantityProductInCartConference(product.id);

    return (
        <>
            {!loading
                ?
                    <div onClick={handleProduct} className={`${className} relative flex flex-col w-full min-h-full hover:text-custom-primary cursor-pointer transition ease-in-out duration-200 ring-1 ring-gray-100 active:ring-2 active:ring-custom-primary md:hover:ring-2 md:hover:ring-custom-primary rounded`}> 
                        <div 
                            className={`relative flex items-center justify-center bg-cover bg-center bg-no-repeat h-full min-h-48 ring-0 ring-opacity-50 ring-gray-200 bg-gray-50 rounded`}
                            style={{backgroundImage: `url('${product.photos?.medium}')`}}
                            >
                            {!product.photos?.thumbnail && <TbPhotoX className='text-gray-100 w-1/2 h-1/2' />}

                            {/* PRODUCT IN CART */}
                            {(quantitySelected > 0) && <SelectedProduct quantity={quantitySelected} />}

                            {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                            {(isNewProductOnCatalog(product.tags) && !product.from_price) && <BadgeNewProduct className='absolute right-2 top-0 rounded-b' /> }

                            {/* PRODUCT SALE  */}
                            {product.from_price > 0 && <BadgeProductSale className='absolute right-2 top-0 rounded-b' />}

                        </div>
                        <h3 className={`
                            absolute bottom-0 w-full p-2 font-bold text-sm
                            ${product.photos?.thumbnail 
                                ? 'drop-shadow-[0_1px_1px_rgba(0,0,0,0.6)] text-white'
                                : 'text-gray-400'
                            }
                            `}>
                            {product.name}
                        </h3>
                    </div>
                :
                    <div className={`${className} relative w-full rounded min-h-40 ring-1 ring-gray-100 bg-gray-200 animate-pulse`}>
                        <div className="absolute bottom-0 m-3 bg-gray-100 h-4 w-1/2 rounded-lg"></div>
                    </div>
            }
        </>
    );
};

export default CardProductGridImage;
